
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/vader",
      function () {
        return require("private-next-pages/[region]/[resort]/vader.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/vader"])
      });
    }
  